import React from 'react';
import { useTranslation } from 'react-i18next';
import Banner from './Banner';
import '../styles/Policy.css';

const Policy = () => {
  const { t, i18n } = useTranslation();
  const isDutch = i18n.resolvedLanguage?.startsWith('nl');
  const sections = [
    ['identification', t('translate.policy_s1_title')],
    ['utilisation', t('translate.policy_s2_title')],
    ['objet', t('translate.policy_s3_title')],
    ['propriete', t('translate.policy_s4_title')],
    ['responsabilite', t('translate.policy_s5_title')],
    ['liens-tiers', t('translate.policy_s6_title')],
    ['cookies', t('translate.policy_s7_title')],
    ['donnees-personnelles', t('translate.policy_s8_title')],
    ['droit-applicable', t('translate.policy_s9_title')]
  ];

  return (
    <div className="policy-page">
      <Banner
        title={t('translate.policy_title')}
        subtitle={isDutch
          ? 'Lees hoe Main Tendue uw gegevens beschermt en welke regels van toepassing zijn op het gebruik van deze website.'
          : 'Découvrez comment Main Tendue protège vos données et encadre l’utilisation de ce site.'}
        accent={isDutch ? 'Privacybeleid' : 'confidentialité'}
      />
      <div className="policy-container">
        <div className="policy-layout">
          <aside className="policy-toc">
            <div className="policy-toc-inner">
              <span className="policy-toc-kicker">{isDutch ? 'Juridisch document' : 'Document juridique'}</span>
              <h2>{isDutch ? 'Inhoud' : 'Sommaire'}</h2>
              <nav aria-label={isDutch ? 'Inhoud van het privacybeleid' : 'Sommaire de la politique de confidentialité'}>
                {sections.map(([id, label], index) => (
                  <a key={id} href={`#${id}`}><span>{String(index + 1).padStart(2, '0')}</span>{label.replace(/^\d+(?:\.\d+)?\.\s*/, '')}</a>
                ))}
              </nav>
              <a className="policy-toc-contact" href="mailto:info@maintendue.be">info@maintendue.be</a>
            </div>
          </aside>

          <article className="policy-content">

        {/* 1. Identification */}
        <section id="identification">
          <h2>{t('translate.policy_s1_title')}</h2>
          <p>{t('translate.policy_s1_intro')}</p>
          <ul>
            <li>{t('translate.policy_s1_item_denom')}</li>
            <li>{t('translate.policy_s1_item_activity')}</li>
            <li>{t('translate.policy_s1_item_agreement')}</li>
            <li>{t('translate.policy_s1_item_company')}</li>
            <li>{t('translate.policy_s1_item_address')}</li>
            <li>{t('translate.policy_s1_item_phone')}</li>
            <li>{t('translate.policy_s1_item_email')}</li>
            <li>{t('translate.policy_s1_item_website')}</li>
          </ul>
          <p>{t('translate.policy_s1_hosting')}</p>
        </section>

        {/* 2. Accès et utilisation */}
        <section id="utilisation">
          <h2>{t('translate.policy_s2_title')}</h2>
          <p>{t('translate.policy_s2_p1')}</p>
          <ul>
            <li>{t('translate.policy_s2_list_item1')}</li>
            <li>{t('translate.policy_s2_list_item2')}</li>
            <li>{t('translate.policy_s2_list_item3')}</li>
          </ul>
          <p>{t('translate.policy_s2_p2')}</p>
          <p>{t('translate.policy_s2_p3')}</p>
        </section>

        {/* 3. Objet du site */}
        <section id="objet">
          <h2>{t('translate.policy_s3_title')}</h2>
          <p>{t('translate.policy_s3_p1')}</p>
          <ul>
            <li>{t('translate.policy_s3_list_item1')}</li>
            <li>{t('translate.policy_s3_list_item2')}</li>
            <li>{t('translate.policy_s3_list_item3')}</li>
            <li>{t('translate.policy_s3_list_item4')}</li>
          </ul>
          <p>{t('translate.policy_s3_p2')}</p>
        </section>

        {/* 4. Propriété intellectuelle */}
        <section id="propriete">
          <h2>{t('translate.policy_s4_title')}</h2>
          <p>{t('translate.policy_s4_p1')}</p>
          <ul>
            <li>{t('translate.policy_s4_list1_item1')}</li>
            <li>{t('translate.policy_s4_list1_item2')}</li>
            <li>{t('translate.policy_s4_list1_item3')}</li>
          </ul>
          <p>{t('translate.policy_s4_p2')}</p>
          <p>{t('translate.policy_s4_p3')}</p>
          <ul>
            <li>{t('translate.policy_s4_list2_item1')}</li>
            <li>{t('translate.policy_s4_list2_item2')}</li>
          </ul>
          <p>{t('translate.policy_s4_p4')}</p>
        </section>

        {/* 5. Fonctionnement technique */}
        <section id="responsabilite">
          <h2>{t('translate.policy_s5_title')}</h2>
          <p>{t('translate.policy_s5_p1')}</p>
          <ul>
            <li>{t('translate.policy_s5_list1_item1')}</li>
            <li>{t('translate.policy_s5_list1_item2')}</li>
            <li>{t('translate.policy_s5_list1_item3')}</li>
          </ul>
          <p>{t('translate.policy_s5_p2')}</p>
          <ul>
            <li>{t('translate.policy_s5_list2_item1')}</li>
            <li>{t('translate.policy_s5_list2_item2')}</li>
            <li>{t('translate.policy_s5_list2_item3')}</li>
          </ul>
          <p>{t('translate.policy_s5_p3')}</p>
          <ul>
            <li>{t('translate.policy_s5_list3_item1')}</li>
            <li>{t('translate.policy_s5_list3_item2')}</li>
            <li>{t('translate.policy_s5_list3_item3')}</li>
          </ul>
          <p>{t('translate.policy_s5_p4')}</p>
          <ul>
            <li>{t('translate.policy_s5_list4_item1')}</li>
            <li>{t('translate.policy_s5_list4_item2')}</li>
          </ul>
        </section>

        {/* 6. Liens hypertextes */}
        <section id="liens-tiers">
          <h2>{t('translate.policy_s6_title')}</h2>
          <p>{t('translate.policy_s6_p1')}</p>
          <p>{t('translate.policy_s6_p2')}</p>
          <ul>
            <li>{t('translate.policy_s6_list1_item1')}</li>
            <li>{t('translate.policy_s6_list1_item2')}</li>
            <li>{t('translate.policy_s6_list1_item3')}</li>
            <li>{t('translate.policy_s6_list1_item4')}</li>
          </ul>
          <p>{t('translate.policy_s6_p3')}</p>
        </section>

        {/* 7. Cookies */}
        <section id="cookies">
          <h2>{t('translate.policy_s7_title')}</h2>
          <p>{t('translate.policy_s7_p1')}</p>
          <ul>
            <li>{t('translate.policy_s7_list1_item1')}</li>
            <li>{t('translate.policy_s7_list1_item2')}</li>
            <li>{t('translate.policy_s7_list1_item3')}</li>
          </ul>
          <p>{t('translate.policy_s7_p2')}</p>
          <ul>
            <li>{t('translate.policy_s7_list2_item1')}</li>
            <li>{t('translate.policy_s7_list2_item2')}</li>
          </ul>
          <p>{t('translate.policy_s7_p3')}</p>
        </section>

        {/* 8. Données personnelles */}
        <section id="donnees-personnelles">
          <h2>{t('translate.policy_s8_title')}</h2>
          <p>{t('translate.policy_s8_p1')}</p>
          <ul>
            <li>{t('translate.policy_s8_list1_item1')}</li>
            <li>{t('translate.policy_s8_list1_item2')}</li>
          </ul>

          <h3>{t('translate.policy_s8_1_title')}</h3>
          <p>{t('translate.policy_s8_1_p1')}</p>

          <h4>{t('translate.policy_s8_1_subtitle_contact')}</h4>
          <ul>
            <li>{t('translate.policy_s8_1_contact_item1')}</li>
            <li>{t('translate.policy_s8_1_contact_item2')}</li>
            <li>{t('translate.policy_s8_1_contact_item3')}</li>
            <li>{t('translate.policy_s8_1_contact_item4')}</li>
            <li>{t('translate.policy_s8_1_contact_item5')}</li>
          </ul>

          <h4>{t('translate.policy_s8_1_subtitle_booking')}</h4>
          <ul>
            <li>{t('translate.policy_s8_1_booking_item1')}</li>
            <li>{t('translate.policy_s8_1_booking_item2')}</li>
            <li>{t('translate.policy_s8_1_booking_item3')}</li>
            <li>{t('translate.policy_s8_1_booking_item4')}</li>
            <li>{t('translate.policy_s8_1_booking_item5')}</li>
            <li>{t('translate.policy_s8_1_booking_item6')}</li>
            <li>{t('translate.policy_s8_1_booking_item7')}</li>
            <li>{t('translate.policy_s8_1_booking_item8')}</li>
          </ul>

          <p>{t('translate.policy_s8_1_p2')}</p>

          <h4>{t('translate.policy_s8_1_subtitle_technical')}</h4>
          <ul>
            <li>{t('translate.policy_s8_1_technical_item1')}</li>
            <li>{t('translate.policy_s8_1_technical_item2')}</li>
          </ul>

          <h3>{t('translate.policy_s8_2_title')}</h3>
          <p>{t('translate.policy_s8_2_p1')}</p>
          <ul>
            <li>{t('translate.policy_s8_2_item1')}</li>
            <li>{t('translate.policy_s8_2_item2')}</li>
            <li>{t('translate.policy_s8_2_item3')}</li>
            <li>{t('translate.policy_s8_2_item4')}</li>
          </ul>
          <p>{t('translate.policy_s8_2_p2')}</p>

          <h3>{t('translate.policy_s8_3_title')}</h3>
          <p>{t('translate.policy_s8_3_p1')}</p>
          <ul>
            <li>{t('translate.policy_s8_3_item1')}</li>
            <li>{t('translate.policy_s8_3_item2')}</li>
            <li>{t('translate.policy_s8_3_item3')}</li>
            <li>{t('translate.policy_s8_3_item4')}</li>
          </ul>

          <h3>{t('translate.policy_s8_4_title')}</h3>
          <p>{t('translate.policy_s8_4_p1')}</p>
          <ul>
            <li>{t('translate.policy_s8_4_item1')}</li>
            <li>{t('translate.policy_s8_4_item2')}</li>
            <li>{t('translate.policy_s8_4_item3')}</li>
          </ul>
          <p>{t('translate.policy_s8_4_p2')}</p>

          <h3>{t('translate.policy_s8_5_title')}</h3>
          <p>{t('translate.policy_s8_5_p1')}</p>
          <ul>
            <li>{t('translate.policy_s8_5_item1')}</li>
            <li>{t('translate.policy_s8_5_item2')}</li>
          </ul>
          <p>{t('translate.policy_s8_5_p2')}</p>

          <h3>{t('translate.policy_s8_6_title')}</h3>
          <p>{t('translate.policy_s8_6_p1')}</p>
          <ul>
            <li>{t('translate.policy_s8_6_item1')}</li>
            <li>{t('translate.policy_s8_6_item2')}</li>
            <li>{t('translate.policy_s8_6_item3')}</li>
            <li>{t('translate.policy_s8_6_item4')}</li>
            <li>{t('translate.policy_s8_6_item5')}</li>
            <li>{t('translate.policy_s8_6_item6')}</li>
            <li>{t('translate.policy_s8_6_item7')}</li>
          </ul>
          <p>{t('translate.policy_s8_6_p2')}</p>
          <p className="policy-contact">
            {t('translate.policy_s8_6_contact')}
          </p>
          <p>{t('translate.policy_s8_6_p3')}</p>
        </section>

        {/* 9. Droit applicable */}
        <section id="droit-applicable">
          <h2>{t('translate.policy_s9_title')}</h2>
          <p>{t('translate.policy_s9_p1')}</p>
          <p>{t('translate.policy_s9_p2')}</p>
          <ul>
            <li>{t('translate.policy_s9_item1')}</li>
            <li>{t('translate.policy_s9_item2')}</li>
          </ul>
        </section>
          </article>
        </div>
      </div>
    </div>
  );
};

export default Policy;
